import { Tooltip, Zoom } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React, { useMemo } from "react";
import { formatCurrency } from "../../../../../../utils/formatters";
import { default as Button } from "../../../../../ui/button";
import Tag from "../../../../../ui/tag";
import { useQueryContext } from "../../../context";

const CellCredor = (data) => {
  if (!data) {
    return "-";
  }

  let qty = data.length;
  let name = data[0];

  if (qty == 0) {
    name = "-";
  }

  if (qty > 1) {
    name = `${name} E MAIS ${qty - 1}`;
  }

  return name;
};

const CellId = (selectPrecatorio, id) => (
  <Tooltip
    arrow
    TransitionComponent={Zoom}
    title={
      <span
        style={{
          fontSize: "11px",
          fontFamily:
            "'Hind Vadodara', sans-serif, 'Open Sans',Arial,Helvetica,Sans-Serif",
        }}
      >
        Ver detalhes
      </span>
    }
  >
    <Button
      size="small"
      style={{ margin: 0 }}
      onClick={() => selectPrecatorio(id)}
      id={`view_precatorio_details_${id}`}
    >
      <InfoOutlinedIcon />
    </Button>
  </Tooltip>
);

const showValue = (value) => value || "-";

export default () => {
  const { selectPrecatorio } = useQueryContext();

  return useMemo(
    () => [
      {
        id: "ordem_pagamento_ente",
        accessor: "attributes.ordem-pagamento-ente",
        style: { textAlign: "center" },
        totalWidth: 250,
        Header: "Posição",
        toggable: true,
        Cell: ({ value }) => showValue(value),
        disableSortBy: true,
      },
      {
        accessor: "attributes.numero-precatorio",
        style: { textAlign: "center" },
        totalWidth: 250,
        Header: "Precatório",
        toggable: false,
        disableSortBy: true,
      },
      {
        accessor: "attributes.valor-atualizado-em-centavos",
        style: { textAlign: "center" },
        Header: "Valor",
        Cell: ({ value }) => (value ? formatCurrency(value) : "Indisponível"),
        toggable: true,
      },
      {
        accessor: "attributes.tribunal",
        style: { textAlign: "center", width: "80px" },
        totalWidth: 80,
        Header: "Tribunal",
        toggable: true,
      },
      {
        accessor: "attributes.natureza",
        style: { textAlign: "center" },
        Header: "Natureza",
        Cell: ({ value }) => showValue(value),
        toggable: true,
      },
      {
        accessor: "attributes.ano-vencimento",
        style: { textAlign: "center" },
        Header: "Vencimento",
        Cell: ({ value }) => showValue(value),
        toggable: true,
      },
      {
        accessor: "attributes.uf",
        style: { textAlign: "center", width: "52px" },
        Header: "UF",
        Cell: ({ value }) => showValue(value),
        toggable: true,
      },
      {
        id: "devedor",
        accessor: "attributes.devedor",
        style: { textAlign: "center" },
        Header: "Devedor",
        Cell: ({ value }) => showValue(value),
        toggable: true,
      },
      {
        id: "credor",
        accessor: "attributes.credores",
        style: { textAlign: "center" },
        Header: "Credor",
        Cell: (props) => CellCredor(props.value),
        toggable: true,
      },
      {
        accessor: "attributes.tags",
        style: { textAlign: "center" },
        Header: "Etiqueta",
        Cell: ({ value }) => (
          <>
            {value?.map((tag) => (
              <Tag key={tag} text={tag} />
            ))}
          </>
        ),
        toggable: true,
        disableSortBy: true,
      },
      {
        accessor: "id",
        style: { textAlign: "center" },
        Header: "",
        Cell: (props) => CellId(selectPrecatorio, props.value),
        toggable: false,
        disableSortBy: true,
      },
    ],
    []
  );
};
